// extracted by mini-css-extract-plugin
export default {"section":"CourtRentCalendar_section__eD6F8","description":"CourtRentCalendar_description__84OKY","chooseCourtButton":"CourtRentCalendar_chooseCourtButton__C+09s"};